<div [ngStyle]="styles" class="wrapper" data-cy="card.component">
  <ng-content select="[card-body]"></ng-content>
</div>
